// import React, { useState, useEffect } from "react";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
// import Avatar from "@mui/material/Avatar";
// import IconButton from "@mui/material/IconButton";
// import Menu from "@mui/material/Menu";
// import Tooltip from "@mui/material/Tooltip";
// import MenuItem from "@mui/material/MenuItem";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";
// import jwt_decode from "jwt-decode";
// import LOGO from "../../Assets/GodrejLogoWhite.png";
// import { decryptRequest } from "../../utils/crypt";
// import { Divider } from "@mui/material";
// import { MdOutlineDashboard } from "react-icons/md";
// import { TbAlertSquare } from "react-icons/tb";
// import { IoCameraOutline } from "react-icons/io5";
// import { MdOutlineSupportAgent } from "react-icons/md";
// import { FaRegUser } from "react-icons/fa";

// function Navbar({ children }) {
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [anchorElUser, setAnchorElUser] = useState(null);
//   const [isActive, setIsActive] = useState(false);

//   const handleOpenUserMenu = (event) => {
//     setAnchorElUser(event.currentTarget);
//   };

//   const handleCloseUserMenu = () => {
//     setAnchorElUser(null);
//   };

//   const handleLogout = async () => {
//     localStorage.removeItem("Dates");
//     localStorage.clear();
//     Cookies.remove("name");
//     navigate("/");
//   };

//   useEffect(() => {
//     let token = localStorage.getItem("token");
//     let path = localStorage.getItem("path");
//     if (path === "/home") {
//       setIsActive(true);
//     }
//     var decoded = jwt_decode(token);
//     decryptRequest(decoded.encryptedData).then((res) => {
//       let { name, email } = JSON.parse(res).data;
//       setName(name);
//       setEmail(email);
//     });
//   }, []);

//   const handleNavigate = (path) => {
//     localStorage.setItem("path", path);
//     navigate(path);
//   };

//   return (
//     <div>
//       <nav className="flex items-center justify-between bg-teal-700 p-4">
//         {/* Logo Section */}
//         <div className="flex items-center space-x-4">
//           <img
//             src={LOGO}
//             className="w-36 h-auto cursor-pointer"
//             alt="LOGO"
//             onClick={() => navigate("/home")}
//           />
//         </div>

//         {/* Mobile Toggle Button */}
//         <div className="md:hidden">
//           <IconButton
//             className="text-white focus:outline-none"
//             onClick={handleOpenUserMenu}
//           >
//             <svg
//               className="w-6 h-6"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M4 6h16M4 12h16m-7 6h7"
//               />
//             </svg>
//           </IconButton>
//         </div>

//         {/* Navbar Links (Visible on Medium Screens and Above) */}
//         <div className="hidden md:flex items-center space-x-8">
//           <Box onClick={() => handleNavigate("/home")}>
//             <div className="flex flex-col items-center cursor-pointer">
//               <MdOutlineDashboard size={30} className="text-white" />
//               <span className="text-white">Dashboard</span>
//             </div>
//           </Box>

//           <Box onClick={() => handleNavigate("/alerts")}>
//             <div className="flex flex-col items-center cursor-pointer">
//               <TbAlertSquare size={30} className="text-white" />
//               <span className="text-white">Alerts</span>
//             </div>
//           </Box>

//           <Box onClick={() => handleNavigate("/addalert")}>
//             <div className="flex flex-col items-center cursor-pointer">
//               <IoCameraOutline size={30} className="text-white" />
//               <span className="text-white">Camera</span>
//             </div>
//           </Box>

//           <Box onClick={() => handleNavigate("/support")}>
//             <div className="flex flex-col items-center cursor-pointer">
//               <MdOutlineSupportAgent size={30} className="text-white" />
//               <span className="text-white">Support</span>
//             </div>
//           </Box>

//           <Box onClick={() => handleNavigate("/users")}>
//             <div className="flex flex-col items-center cursor-pointer">
//               <FaRegUser size={30} className="text-white" />
//               <span className="text-white">Users</span>
//             </div>
//           </Box>
//         </div>

//         {/* Profile Section */}
//         <div className="flex items-center space-x-4">
//           <Tooltip title="Open profile">
//             <IconButton onClick={handleOpenUserMenu}>
//               <Avatar
//                 alt={name.split(" ")[0]}
//                 src="/static/images/avatar/2.jpg"
//               />
//             </IconButton>
//           </Tooltip>

//           <Menu
//             id="menu-appbar"
//             anchorEl={anchorElUser}
//             anchorOrigin={{ vertical: "top", horizontal: "right" }}
//             keepMounted
//             transformOrigin={{ vertical: "top", horizontal: "right" }}
//             open={Boolean(anchorElUser)}
//             onClose={handleCloseUserMenu}
//           >
//             <MenuItem onClick={handleCloseUserMenu}>
//               <Typography textAlign="center">Name: {name}</Typography>
//             </MenuItem>
//             <Divider />
//             <MenuItem onClick={handleCloseUserMenu}>
//               <Typography textAlign="center">Email: {email}</Typography>
//             </MenuItem>
//             <Divider />
//             <MenuItem onClick={handleLogout} className="bg-red-500 text-black">
//               Logout
//             </MenuItem>
//           </Menu>
//         </div>
//       </nav>

//       {/* Content */}
//       <div className="p-4">{children}</div>
//     </div>
//   );
// }

// export default Navbar;

// import React, { useState, useEffect } from "react";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
// import Avatar from "@mui/material/Avatar";
// import IconButton from "@mui/material/IconButton";
// import Menu from "@mui/material/Menu";
// import Tooltip from "@mui/material/Tooltip";
// import MenuItem from "@mui/material/MenuItem";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";
// import jwt_decode from "jwt-decode";
// import LOGO from "../../Assets/GodrejLogoWhite.png";
// import { decryptRequest } from "../../utils/crypt";
// import { Divider } from "@mui/material";
// import { MdOutlineDashboard } from "react-icons/md";
// import { TbAlertSquare } from "react-icons/tb";
// import { IoCameraOutline } from "react-icons/io5";
// import { MdOutlineSupportAgent } from "react-icons/md";
// import { FaRegUser } from "react-icons/fa";

// function Navbar({ children }) {
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [anchorElUser, setAnchorElUser] = useState(null);
//   const [isActive, setIsActive] = useState(false);

//   const handleOpenUserMenu = (event) => {
//     setAnchorElUser(event.currentTarget);
//   };

//   const handleCloseUserMenu = () => {
//     setAnchorElUser(null);
//   };

//   const handleLogout = async () => {
//     localStorage.removeItem("Dates");
//     localStorage.clear();
//     Cookies.remove("name");
//     navigate("/");
//   };

//   useEffect(() => {
//     let token = localStorage.getItem("token");
//     let path = localStorage.getItem("path");
//     if (path === "/home") {
//       setIsActive(true);
//     }
//     var decoded = jwt_decode(token);
//     decryptRequest(decoded.encryptedData).then((res) => {
//       let { name, email } = JSON.parse(res).data;
//       setName(name);
//       setEmail(email);
//     });
//   }, []);

//   const handleNavigate = (path) => {
//     localStorage.setItem("path", path);
//     navigate(path);
//   };

//   return (
//     <div>
//       <nav className="flex items-center justify-between bg-teal-700 p-4 shadow-lg">
//         {/* Logo Section */}
//         <div className="flex items-center space-x-4">
//           <img
//             src={LOGO}
//             className="w-36 h-auto cursor-pointer"
//             alt="LOGO"
//             onClick={() => navigate("/home")}
//           />
//         </div>

//         {/* Navbar Links (Visible on Medium Screens and Above) */}
//         <div className="hidden md:flex items-center space-x-8">
//           {[
//             {
//               icon: <MdOutlineDashboard size={30} />,
//               label: "Dashboard",
//               path: "/home",
//             },
//             {
//               icon: <TbAlertSquare size={30} />,
//               label: "Alerts",
//               path: "/alerts",
//             },
//             {
//               icon: <IoCameraOutline size={30} />,
//               label: "Camera",
//               path: "/addalert",
//             },
//             {
//               icon: <MdOutlineSupportAgent size={30} />,
//               label: "Support",
//               path: "/support",
//             },
//             { icon: <FaRegUser size={30} />, label: "Users", path: "/users" },
//           ].map(({ icon, label, path }) => (
//             <Box key={label} onClick={() => handleNavigate(path)}>
//               <div className="flex flex-col items-center cursor-pointer transition-transform duration-300 hover:scale-105 hover:text-yellow-500">
//                 {icon}
//                 <span className="text-white">{label}</span>
//               </div>
//             </Box>
//           ))}
//         </div>

//         {/* Profile Section */}
//         <div className="flex items-center space-x-4">
//           <Tooltip title="Open profile">
//             <IconButton onClick={handleOpenUserMenu}>
//               <Avatar
//                 alt={name.split(" ")[0]}
//                 src="/static/images/avatar/2.jpg"
//               />
//             </IconButton>
//           </Tooltip>

//           <Menu
//             id="menu-appbar"
//             anchorEl={anchorElUser}
//             anchorOrigin={{ vertical: "top", horizontal: "right" }}
//             keepMounted
//             transformOrigin={{ vertical: "top", horizontal: "right" }}
//             open={Boolean(anchorElUser)}
//             onClose={handleCloseUserMenu}
//             className="mt-2"
//           >
//             <MenuItem onClick={handleCloseUserMenu}>
//               <Typography textAlign="center">Name: {name}</Typography>
//             </MenuItem>
//             <Divider />
//             <MenuItem onClick={handleCloseUserMenu}>
//               <Typography textAlign="center">Email: {email}</Typography>
//             </MenuItem>
//             <Divider />
//             <MenuItem
//               onClick={handleLogout}
//               className="bg-red-500 text-white hover:bg-red-700"
//             >
//               Logout
//             </MenuItem>
//           </Menu>
//         </div>
//       </nav>

//       {/* Content */}
//       <div className="p-6 bg-gray-50 min-h-screen">{children}</div>
//     </div>
//   );
// }

// export default Navbar;
import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import LOGO from "../../Assets/GodrejLogoWhite.png";
import { decryptRequest } from "../../utils/crypt";
import { Divider } from "@mui/material";
import { MdOutlineDashboard } from "react-icons/md";
import { TbAlertSquare } from "react-icons/tb";
import { IoCameraOutline } from "react-icons/io5";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";

function Navbar({ children }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [userType, setUserType] = useState("");
  const [selectedOption, setSelectedOption] = useState("/home"); // Track selected option
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = async () => {
    localStorage.removeItem("Dates");
    localStorage.clear();
    Cookies.remove("name");
    navigate("/");
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    let path = localStorage.getItem("path");
    if (path) {
      setSelectedOption(path);
    }
    var decoded = jwt_decode(token);
    decryptRequest(decoded.encryptedData).then((res) => {
      let { name, email, userType } = JSON.parse(res).data;
      setName(name);
      setEmail(email);
      setUserType(userType);
    });
  }, []);

  const handleNavigate = (path) => {
    localStorage.setItem("path", path);
    setSelectedOption(path); // Update the selected option
    navigate(path);
  };

  const navOptions = [
    {
      icon: <MdOutlineDashboard size={30} />,
      label: "Dashboard",
      path: "/home",
    },
    { icon: <TbAlertSquare size={30} />, label: "Alerts", path: "/alerts" },
    { icon: <IoCameraOutline size={30} />, label: "Camera", path: "/addalert" },
    {
      icon: <MdOutlineSupportAgent size={30} />,
      label: "Support",
      path: "/support",
    },
  ];
  if (userType !== "HSE") {
    navOptions.push({
      icon: <FaRegUser size={30} />,
      label: "Users",
      path: "/users",
    });
  }

  return (
    <div>
      <nav className="flex items-center justify-between bg-teal-700 p-4 shadow-lg">
        {/* Logo Section */}
        <div className="flex items-center space-x-4">
          <img
            src={LOGO}
            className="w-36 h-8 cursor-pointer"
            alt="LOGO"
            onClick={() => handleNavigate("/home")}
          />
          {/* Display selected option text next to the logo */}
          {/* <Typography variant="h6" className="text-yellow-500 font-semibold">
            {navOptions.find((option) => option.path === selectedOption)?.label}
          </Typography> */}
        </div>

        {/* Navbar Links */}
        <div className="hidden md:flex items-center space-x-8">
          {navOptions.map(({ icon, label, path }) => (
            <Box key={label} onClick={() => handleNavigate(path)}>
              <div
                className={`flex flex-col items-center cursor-pointer transition-transform duration-300 hover:scale-105 hover:text-yellow-500 ${
                  selectedOption === path
                    ? "text-yellow-500 font-semibold"
                    : "text-white"
                }`}
              >
                {icon}
                <span>{label}</span>
              </div>
            </Box>
          ))}
        </div>

        {/* Profile Section */}
        <div className="flex items-center space-x-4">
          <Tooltip title="Open profile">
            <IconButton onClick={handleOpenUserMenu}>
              <Avatar
                alt={name.split(" ")[0]}
                src="/static/images/avatar/2.jpg"
              />
            </IconButton>
          </Tooltip>

          <Menu
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            keepMounted
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
            className="mt-2"
          >
            <MenuItem onClick={handleCloseUserMenu}>
              <Typography textAlign="center">Name: {name}</Typography>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleCloseUserMenu}>
              <Typography textAlign="center">Email: {email}</Typography>
            </MenuItem>
            <Divider />
            <MenuItem
              onClick={handleLogout}
              className="bg-teal-700 text-white hover:bg-teal-600"
              style={{ backgroundColor: "teal" }}
            >
              Logout
            </MenuItem>
          </Menu>
        </div>
      </nav>

      {/* Content */}
      <div className="p-6 bg-gray-50 min-h-screen">{children}</div>
    </div>
  );
}

export default Navbar;
